const BLOG_TITLE = "Блог";
const BLOG_SUBTITLE = "Делимся полезным опытом, накопленным за годы работы в продвижении";
const NO_ARTICLES = "Ничего не найдено";

export { BLOG_TITLE, BLOG_SUBTITLE, NO_ARTICLES };